import zIndexCalculator from './z-index-calculator';
var panelPropsToCss = function panelPropsToCss(_ref) {
  var isOpen = _ref.isOpen,
    maxWidth = _ref.maxWidth,
    order = _ref.order,
    direction = _ref.direction;
  var oppositeDirection = direction === 'left' ? 'right' : 'left';
  var positionProps = '';
  if (maxWidth) {
    var offset = maxWidth ? "".concat(maxWidth * -1, "px") : '100%';
    positionProps = "\n      max-width: ".concat(maxWidth, "px;\n      ").concat(direction, ": ").concat(isOpen ? 0 : offset, ";\n      ").concat(oppositeDirection, ": auto;\n    ");
  }
  return "\n    box-shadow: ".concat(isOpen ? '0px 0px 28px 2px rgba(0,0,0,0.10)' : 'none', ";\n    transition: ").concat(direction, " 300ms ease-out;\n    z-index: ").concat(zIndexCalculator('panel', order), ";\n    ").concat(positionProps, ";\n  ");
};
export default panelPropsToCss;